import { render, staticRenderFns } from "./SchoolUser.vue?vue&type=template&id=3ccd8bd9&scoped=true"
import script from "./SchoolUser.vue?vue&type=script&lang=js"
export * from "./SchoolUser.vue?vue&type=script&lang=js"
import style0 from "./SchoolUser.vue?vue&type=style&index=0&id=3ccd8bd9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ccd8bd9",
  null
  
)

export default component.exports